import type { ILink } from "@frontiers-vue3/public-pages";
import type { IResearchTopic } from "~/types";

export const buildClib3Breadcrumbs = (
  researchTopic: IResearchTopic,
  url: string
): ILink[] => {
  const { isCallForPapersVisible } = useEnvironmentConfigStore().getConfig();
  const terminology = useTerminologyStore();

  const useCorrectTerm = (cfp: string, rt: string): string => {
    return isCallForPapersVisible && researchTopic.isOpenForSubmission
      ? cfp
      : rt;
  };

  const rtLinkText = useCorrectTerm(
    terminology.getTerm("callForPapers"),
    terminology.getTerm("researchTopics")
  );

  const rtLinkTo = (url: string) =>
    useCorrectTerm(`${url}/call-for-papers`, `${url}/research-topics`);

  const breadCrumbItems = computed((): ILink[] => {
    const items = new Array<ILink>();
    let primaryJournal = researchTopic.journals.find(
      (journal) => journal.isPrimary
    );

    if (!primaryJournal && researchTopic.journals.length) {
      primaryJournal = researchTopic.journals[0];
    }

    const onlineSection = primaryJournal?.sections?.find((s) => s.isOnline);

    items.push({
      text: "Home",
      url: "/"
    });

    if (primaryJournal?.isOnline) {
      url = url + `/journals/${primaryJournal.slug}`;
      items.push({ text: primaryJournal.title, url });
    } else {
      items.push({ text: primaryJournal?.title || "", url: "" });
    }

    if (onlineSection) {
      url = url + `/sections/${onlineSection.slug}`;
      items.push({ text: onlineSection.title, url });
    } else if (primaryJournal?.sections?.length) {
      items.push({ text: primaryJournal?.sections[0].title, url: "" });
    }

    items.push({ text: rtLinkText, url: rtLinkTo(url) });

    items.push({
      text: useSanitizeHtml(researchTopic.title, {
        ALLOWED_TAGS: ["sub", "sup"]
      }),
      url: ""
    });
    return items;
  });

  return breadCrumbItems.value;
};
